module.exports = __webpack_public_path__ + "img/game-1.ba443d38.png";